import * as e from "react";
import { forwardRef as l } from "react";
const r = l(function(C, t) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: t,
      viewBox: "0 0 24 20",
      xmlns: "http://www.w3.org/2000/svg",
      ...C
    },
    /* @__PURE__ */ e.createElement("path", { d: "M19.5703 20H0L3.42965 0H23L19.5703 20Z", fill: "#32B7CD" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M9.85645 13.5H4.9834V12.5332L7.2832 10.082C7.59896 9.73698 7.83171 9.43587 7.98145 9.17871C8.13444 8.92155 8.21094 8.67741 8.21094 8.44629C8.21094 8.13053 8.13118 7.88314 7.97168 7.7041C7.81217 7.52181 7.58431 7.43066 7.28809 7.43066C6.96908 7.43066 6.7168 7.54134 6.53125 7.7627C6.34896 7.98079 6.25781 8.26888 6.25781 8.62695H4.8418C4.8418 8.19401 4.94434 7.7985 5.14941 7.44043C5.35775 7.08236 5.65072 6.80241 6.02832 6.60059C6.40592 6.39551 6.83398 6.29297 7.3125 6.29297C8.04492 6.29297 8.61296 6.46875 9.0166 6.82031C9.4235 7.17188 9.62695 7.66829 9.62695 8.30957C9.62695 8.66113 9.53581 9.01921 9.35352 9.38379C9.17122 9.74837 8.85872 10.1732 8.41602 10.6582L6.7998 12.3623H9.85645V13.5Z",
        fill: "#000"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M14.6522 6.65217C14.8995 6.40484 15.3005 6.40484 15.5479 6.65217L18.0812 9.18551C18.3285 9.43284 18.3285 9.83384 18.0812 10.0812C17.8339 10.3285 17.4328 10.3285 17.1855 10.0812L15.1 7.99568L13.0145 10.0812C12.7672 10.3285 12.3662 10.3285 12.1188 10.0812C11.8715 9.83384 11.8715 9.43284 12.1188 9.18551L14.6522 6.65217ZM15.1 11.1957L13.0145 13.2812C12.7672 13.5286 12.3662 13.5286 12.1188 13.2812C11.8715 13.0339 11.8715 12.6329 12.1188 12.3856L14.6522 9.85222C14.8995 9.60489 15.3005 9.60489 15.5479 9.85222L18.0812 12.3856C18.3285 12.6329 18.3285 13.0339 18.0812 13.2812C17.8339 13.5286 17.4328 13.5286 17.1855 13.2812L15.1 11.1957Z",
        fill: "#000",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  r as TwoUpIcon
};
